import clsx from 'clsx';

interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  color?: 'white' | 'purple' | 'violet' | 'blue' | 'green' | 'gray';
  className?: string;
}

const sizeClasses = {
  xs: 'w-3 h-3 border',
  sm: 'w-4 h-4 border-2',
  md: 'w-5 h-5 border-2',
  lg: 'w-6 h-6 border-2',
  xl: 'w-8 h-8 border-4',
};

const colorClasses = {
  white: 'border-white border-t-transparent',
  purple: 'border-purple-500 border-t-transparent',
  violet: 'border-violet-500 border-t-transparent',
  blue: 'border-blue-500 border-t-transparent',
  green: 'border-green-500 border-t-transparent',
  gray: 'border-zinc-600 border-t-transparent',
};

export const LoadingSpinner = ({
  size = 'md',
  color = 'white',
  className = '',
}: LoadingSpinnerProps) => {
  return (
    <div
      className={clsx(
        'rounded-full animate-spin',
        sizeClasses[size],
        colorClasses[color],
        className,
      )}
    />
  );
};
